import gql from 'graphql-tag';

export default gql`
  mutation ($input: uploadPremiumHEMLogoInput!) {
    uploadPremiumHEMLogo(input: $input) {
      scanAndUploadSuccess
      logoPath
      url
    }
  }
`;
